import React, { useState, useEffect } from "react"
import { Typography } from "antd"
import { useTitle } from "hooks/useTitle"
import { useTranslation } from "react-i18next"
import { modelSelector } from "store/selectors"
import { useDispatch, useSelector } from "react-redux"
import { cleanTrips } from "store/trips"
import { guideSelector } from "store/user"
import { VideoPlayerModal } from "ui/VideoPlayerModal"
import { isMediaFileVideo } from "utils/media-upload"
import PhotoGrid from "components/common/PhotoGrid"
import styles from "./index.module.css"
import { getGuideAbout } from "store/guide-profile"
import { useParams } from "react-router-dom"
import FirstLoading from "modules/loader-watchers/FirstLoading"

const { Title } = Typography

export default function GuideAbout() {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const guideAbout = useSelector((store) => store.guideProfile.about.data)
  const loading = useSelector((store) => store.guideProfile?.about?.loading)
  const guide = useSelector(guideSelector) || {}
  const tripGuide = useSelector(modelSelector("guide"))
  useTitle(guideAbout?.display_name)

  const { slug } = useParams()

  useEffect(() => {
    dispatch(getGuideAbout(slug))
  }, [slug, dispatch])

  const media = [...(guideAbout?.photos || []), ...(guideAbout?.videos || [])]
    .filter((item) => item?.url)
    .sort((a, b) => (a?.position || 0) - (b?.position || 0))

  const [videoModalOpen, setVideoModalOpen] = useState(false)
  const [selectedMedia, setSelectedMedia] = useState(null)

  const handleMediaClick = (media) => {
    if (isMediaFileVideo(media)) {
      setSelectedMedia(media)
      setVideoModalOpen(true)
    }
  }

  const handleCloseVideoModal = () => {
    setVideoModalOpen(false)
    setSelectedMedia(null)
  }

  useEffect(() => {
    return () => dispatch(cleanTrips())
  })

  return (
    <FirstLoading loading={loading} name="guideProfile.about">
      <div className={styles.container}>
        {media?.length > 0 && (
          <PhotoGrid
            photos={media}
            handleMediaClick={handleMediaClick}
            guideName={tripGuide?.display_name || guide?.display_name}
          />
        )}

        <section className={styles.aboutSection}>
          <Title level={2} className={styles.sectionTitle}>
            {t("global.about")}
          </Title>
          <div className={styles.aboutDescription}>{guideAbout?.description}</div>
        </section>

        <VideoPlayerModal open={videoModalOpen} handleClose={handleCloseVideoModal} selectedMedia={selectedMedia} />
      </div>
    </FirstLoading>
  )
}
